import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Header from "@/components/app/Header";
import { useSeo } from "@/lib/seo";

export default function Signup() {
  useSeo({
    title: "Create an account",
    description: "Sign up free to start a Chapter event — collect video memories from friends and family and stitch them into a cinematic tribute film. No credit card required.",
    path: "/signup",
  });
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await signup(email, password, name);
    setBusy(false);
    if (r.ok) { toast.success("Welcome to Chapter"); navigate("/dashboard"); }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-screen bg-[var(--em-bg)]">
      <Header />
      <div className="max-w-md mx-auto px-6 pt-16 pb-24">
        <p className="font-mono-label text-[var(--em-clay)]">Begin a memory</p>
        <h1 className="font-serif-em text-4xl mt-3">Create your account.</h1>
        <p className="mt-2 text-[var(--em-ink-soft)]">Welcome to Chapter — free while we're building. No card needed.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="name" className="font-mono-label">Your name</Label>
            <Input id="name" data-testid="signup-name-input" required value={name} onChange={(e) => setName(e.target.value)} className="mt-2 h-11 bg-white" />
          </div>
          <div>
            <Label htmlFor="email" className="font-mono-label">Email</Label>
            <Input id="email" data-testid="signup-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 bg-white" />
          </div>
          <div>
            <Label htmlFor="password" className="font-mono-label">Password</Label>
            <Input id="password" data-testid="signup-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11 bg-white" />
          </div>
          <Button data-testid="signup-submit-btn" disabled={busy} className="w-full h-11 rounded-full bg-[var(--em-clay)] hover:bg-[var(--em-clay-deep)] text-white btn-lift">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-[var(--em-ink-soft)]">
          Already with us?{" "}
          <Link to="/login" data-testid="signup-go-login" className="text-[var(--em-clay)] underline underline-offset-4">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
